import * as z from "zod";

export const JourneySchema = z.object({
  uuid: z.union([z.null(), z.string()]).nullish(),
  venueName: z.string().nullish(),
  serviceSetUp: z.string().nullish(),
  styleOfBusiness: z.string().nullish(),
  interestedFeatures: z.union([z.array(z.any()), z.null()]).nullish(),
  email: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  countryCode: z.string().nullish(),
  role: z.string().nullish(),
  venueStatus: z.string().nullish(),
  biggestChallenge: z.string().nullish(),
  furtherQuestions: z.string().nullish(),
  goLiveDate: z.string().nullish(),
  partnerContact: z.string().nullish(),
  talkToSomeone: z.string().nullish(),
  phoneNumber: z.string().nullish(),
  hardwareHelp: z.string().nullish(),
  city: z.string().nullish(),
  subcountry: z.string().nullish(),
});
export type Journey = z.infer<typeof JourneySchema>;

export interface Progress {
  currentStep: number;
  totalSteps: number;
}

export interface PageProps {
  progress: Progress;
}
